import { render, staticRenderFns } from "./LabourRateForm.vue?vue&type=template&id=e4f06e28"
import script from "./LabourRateForm.vue?vue&type=script&lang=ts"
export * from "./LabourRateForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports